/* global __GDC_API__ */

import { fetch } from 'utils/ajax';
import { handleActions } from 'redux-actions';
import _ from 'lodash';
import { REHYDRATE } from 'redux-persist';

export let NOTIFICATION_SUCCESS = 'gdc/NOTIFICATION_SUCCESS';
export let NOTIFICATION_DISMISS = 'gdc/NOTIFICATION_DISMISS';

export function fetchNotifications() {
  return async dispatch => {
    let response = await fetch({
      url: `${__GDC_API__}/notifications`,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    let { data } = await response.json();

    dispatch({
      type: NOTIFICATION_SUCCESS,
      payload: data,
    });
  };
}

export function dismissNotification(notificationID) {
  return {
    type: NOTIFICATION_DISMISS,
    payload: { id: notificationID },
  };
}

let initialState = [];
export default handleActions(
  {
    [REHYDRATE]: (state, action) => {
      const incoming = _.uniqBy(
        (action.payload || {}).notifications,
        ({ id }) => id
      );
      if (incoming) return [...state, ...incoming];
      return state;
    },
    [NOTIFICATION_SUCCESS]: (state, action) => {
      return _.uniqBy(
        [
          ...state,
          ...action.payload
            .filter(
              n =>
                _.includes(n.components, 'SUBMISSION') ||
                _.includes(n.components, 'API')
            )
            .map(n => ({ ...n, dismissed: false })),
        ],
        ({ id }) => id
      );
    },
    [NOTIFICATION_DISMISS]: (state, action) =>
      state.map(n => ({
        ...n,
        dismissed: n.id === action.payload.id ? true : n.dismissed,
      })),
  },
  initialState
);
